import {RecipientType} from "./global";

export interface EmailNotificationChannelLogRecipientDto {
    recipientEmail: string;
    recipientType: RecipientType;
    status?: string;
}

export enum NotificationMethodEnum {
    email = 'EMAIL',
    teams = 'MS_TEAMS',
    slack = 'SLACK',
    mobilePush = 'MOBILE_PUSH',
}

export interface EmailNotificationAttachmentResponseDto {
    name: string;
    content: string;
    type: string;
    calendarEvent: boolean;
}

export interface GeneralEmailNotificationDto {
    id: number;
    tenantId: string;
    senderEmail?: string;
    senderName?: string;
    subject?: string;
    title?: string;
    notificationMethod: NotificationMethodEnum;
    recipients: EmailNotificationChannelLogRecipientDto[];
    created: string | null;
    body: string;
    attachments?: EmailNotificationAttachmentResponseDto[];
}

export interface NotificationQueryParams {
    id: number,
    token: string,
    type: NotificationMethodEnum,
    apiKey: string
}